// extracted by mini-css-extract-plugin
export default {"image":"T1-z","loaded":"U1-z"};